import { IBuildInfo } from '@app/api/interfaces/build-info';

export const appContextKey = 'appContext';

export interface IBaseAppContextObject<T> {
  data: T | null;
  loading: boolean;
  loaded: boolean;
}

export interface IAppContextState {
  buildInfo: IBaseAppContextObject<IBuildInfo>;
}

export const initialAppContextState: IAppContextState = {
  buildInfo: { data: null, loading: false, loaded: false },
};
